import CoreOnboardingView from '../../../../core/views/Onboarding'
// Import Onboarding steps
import NoMatchStartPlaying from './steps/NoMatchStartPlaying';
import MatchStartPlaying from './steps/MatchStartPlaying';

// Used to change backgrounds on each step of onboarding
const bg_classes = [
	'bg-1',
	'bg-2',
	'bg-3',
	'bg-4',
	'bg-5',
	'bg-6'
];

class OnboardingView extends CoreOnboardingView {
	showNoMatchStartPlaying() {
		this.showStep(NoMatchStartPlaying, bg_classes[5]);
	}

	showMatchStartPlaying() {
		this.showStep(MatchStartPlaying, bg_classes[1]);
	}
}

export default OnboardingView;